<template>
  <div class="comment-block">
    <div class="comment-header">
      <strong>Комментарии: {{comments.length}}</strong>
      <font-awesome-icon 
      :class="{'icon':activeReload,'icon-disabled':!activeReload}" 
      icon="fa-solid fa-rotate" 
      @click="updateComment" />
    </div>
    <ul v-if="comments" class="comment-list">
      <li v-for="comment in comments" :key="comment.id" class="comment-item">
        <div class="comment-info">
          <p class="comment-usermane">{{ comment.user.name }}</p>
          <p class="date-comment">{{comment.created_dt.substring(0,10)}}</p>
        </div>
        <div class="comment-text">
          <p >{{ comment.text }}</p>
        </div>
      </li>
    </ul>
    <div class="add-comment">
      <textarea v-model="newComment" placeholder="Добавить комментарий"></textarea>
      <button @click="addComment">Отправить</button>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'comment-block',
  props: ['comments'],
  setup(_,{emit}) {
    const newComment = ref('');
    const activeReload = ref(true)

    const addComment = () => {
      if (newComment.value.trim() !== '') {
        emit('addComment',newComment.value)
        newComment.value = '';
      }
    };

    const updateComment = async()=>{
      if(!activeReload.value) return
      activeReload.value = false
      emit('updateComment')
      setTimeout(() => {
          activeReload.value = true 
      }, 20000);
    }

    return {
      activeReload,
      updateComment,
      newComment,
      addComment,
    };
  },
};
</script>

<style scoped>
.comment-block {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.comment-header{
  margin-left: 5px;
  margin-right: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.comment-list {
  list-style: none;
  padding: 0;
}

.comment-item {
  display: flex;
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 5px;
}

.comment-info{
  text-align: left;
  font-size: 16px;
}

.date-comment{
 font-size: 12px; 
}

.comment-text{
  font-size: 12px;
  flex: 1;
  display: flex;
  margin-left: 30px;
  text-align: left;
}

.add-comment {
  margin-top: 20px;
}

textarea {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: vertical;
}

button {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: #007BFF;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

.icon{
  padding: 3px;
  width: 17px;
  height: 17px;
  margin-left: 10px;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
}

.icon-disabled{
  padding: 3px;
  width: 17px;
  height: 17px;
  margin-left: 10px;
  border-radius: 5px;
  background-color: #ccc;
  color: white;
}
</style>

